export const ACTIONS_PREFIX = 'PlaceProfile';
